"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _constants = require("@/utils/constants.js");
var _index = require("@/utils/index");
function _default(handlePageChange) {
  var pageData = (0, _index.deepCopy)(_constants.defaultPageData);
  // 处理分页逻辑
  function handleSizeChange(size) {
    pageData.limit = size;
    handlePageChange();
  }
  function handleCurrentChange(page) {
    pageData.page = page;
    handlePageChange();
  }
  function resetPageData() {
    pageData.page = 1;
    pageData.limit = 20;
    handlePageChange();
  }
  return {
    pageData: pageData,
    handleSizeChange: handleSizeChange,
    handleCurrentChange: handleCurrentChange,
    resetPageData: resetPageData
  };
}